import React from 'react';
import PropTypes from 'prop-types';

import {
  PageWrapper,
  PageViewport,
  PageContent,
} from 'components/PageStyles';
import Link from 'data/Link';

import summaryShape from 'Workspace/types/pluginSummary';
import { collaboratorSummaryShape } from 'Workspace/types/collaborator';
import manifestShape from 'Workspace/types/pluginManifest';

import Sidebar from 'Workspace/components/WorkspaceSidebar';
import HomeNavigation from 'Workspace/components/HomeNavigation';
import WorkspaceHeader from 'Workspace/components/WorkspaceHeader';

import PluginDetailsCard from './PluginDetailsCard';
import PluginSettingsCard from './PluginSettingsCard';
import PluginSharingCard from './PluginSharingCard';
import PluginDeveloperCard from './PluginDeveloperCard';
import PluginSchemaCard from './PluginSchemaCard';

const PluginDetails = ({
  summary,
  manifest,
  pluginId,
  collaborators,
  onRevoke,
  currentUser,
}) => {
  const renderPluginSettingsCard = () => {
    if (!currentUser || !summary || currentUser.accountId !== summary.creator.accountId) {
      return null;
    }

    return (
      <PluginSettingsCard summary={summary} />
    );
  };

  return (
    <PageWrapper>
      <Sidebar navigation={<HomeNavigation selectedKey="plugins" />} />
      <PageViewport>
        <WorkspaceHeader
          links={[
            new Link('/plugins', 'Plugins'),
          ]}
          title={summary ? summary.name : pluginId}
        />
        <PageContent>
          { manifest && <PluginDetailsCard summary={summary} /> }
          {renderPluginSettingsCard()}
          <PluginSharingCard collaborators={collaborators} pluginId={pluginId} onRevoke={onRevoke} />
          { manifest && <PluginSchemaCard manifest={manifest} /> }
          <PluginDeveloperCard summary={summary} />
        </PageContent>
      </PageViewport>
    </PageWrapper>
  );
};
PluginDetails.propTypes = {
  pluginId: PropTypes.string,
  summary: summaryShape,
  manifest: manifestShape,
  collaborators: collaboratorSummaryShape,
  onRevoke: PropTypes.func,
  currentUser: PropTypes.shape({
    accountId: PropTypes.string.isRequired,
  }),
};

export default PluginDetails;
